import { ConnectManualModal } from '../modals/help/connectManualModal'
import { useLinkage } from './useLinkage'
import { useTranslator } from '../translator/hook'
import { SetupSlideButtonConnect } from './setupSlideButtonConnect'
import { useConnectManualModal } from './useConnectManualModal'

export const LinkageButtonSetupSlide = () => {
  const { t } = useTranslator()
  const { connected, hasCheckedStatus, code, label } = useLinkage()
  const { isOpen, open, close } = useConnectManualModal()
  return (
    <>
      <SetupSlideButtonConnect
        connected={connected}
        onClick={open}
        aria-disabled={!hasCheckedStatus}
        tooltipLabel={`${label}${connected ? t('linked') : t('link')}`}
      />

      <ConnectManualModal isOpen={isOpen} onClose={close} code={code} />
    </>
  )
}
